import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mindmap-sidebar" }
const _hoisted_2 = { class: "sidebar-tabs" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  key: 0,
  class: "no-selection"
}
const _hoisted_5 = {
  key: 1,
  class: "properties-container"
}
const _hoisted_6 = { class: "property-header" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = { class: "properties-list" }
const _hoisted_9 = { class: "property-item" }
const _hoisted_10 = {
  key: 0,
  class: "property-value"
}
const _hoisted_11 = { class: "description-display" }
const _hoisted_12 = {
  key: 1,
  class: "property-value"
}
const _hoisted_13 = { class: "d-flex gap-2 mt-2" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "property-item"
}
const _hoisted_17 = { class: "property-value" }
const _hoisted_18 = { class: "badge bg-secondary" }
const _hoisted_19 = { class: "property-item" }
const _hoisted_20 = {
  key: 0,
  class: "property-value"
}
const _hoisted_21 = { class: "description-display" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 1,
  class: "property-value",
  style: {"align-items":"end","flex-direction":"column"}
}
const _hoisted_25 = { class: "d-flex gap-2 mt-2" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "property-item" }
const _hoisted_29 = { class: "property-value" }
const _hoisted_30 = { class: "property-item" }
const _hoisted_31 = { class: "property-value" }
const _hoisted_32 = { class: "color-picker-wrapper" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "text-muted small ms-2" }
const _hoisted_35 = { class: "property-item" }
const _hoisted_36 = { class: "property-value" }
const _hoisted_37 = { class: "color-picker-wrapper" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "text-muted small ms-2" }
const _hoisted_40 = { class: "ai-chat-container" }
const _hoisted_41 = { class: "ai-chat-header" }
const _hoisted_42 = { class: "ai-chat-title" }
const _hoisted_43 = { class: "ms-2" }
const _hoisted_44 = { class: "text-muted extra-small" }
const _hoisted_45 = { class: "ai-chat-badges" }
const _hoisted_46 = {
  key: 0,
  class: "streaming-dot-wrapper"
}
const _hoisted_47 = {
  key: 1,
  class: "token-count-pill"
}
const _hoisted_48 = {
  key: 0,
  class: "chat-empty-state"
}
const _hoisted_49 = {
  key: 1,
  class: "chat-messages"
}
const _hoisted_50 = { class: "ai-message-bubble" }
const _hoisted_51 = { class: "ai-message-header" }
const _hoisted_52 = { class: "ai-message-actions" }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = {
  key: 0,
  class: "streaming-cursor"
}
const _hoisted_55 = {
  key: 1,
  class: "ai-thinking-small"
}
const _hoisted_56 = { class: "ai-chat-footer" }
const _hoisted_57 = {
  key: 1,
  class: "chat-footer-actions"
}
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]

import { ref, watch, computed, nextTick } from "vue";
import PromptPanel from "./PromptPanel.vue";
import { useMindmapStore } from "@/store/mindmap";
import apiService from "@/services/apiService";


export default /*@__PURE__*/_defineComponent({
  __name: 'MindmapSidebar',
  props: {
    selectedNode: {},
    aiResponse: {},
    isRunningPrompt: { type: Boolean },
    responseTokenCount: {},
    selectedModel: {}
  },
  emits: [
  "close-properties", 
  "add-child-node", 
  "run-prompt", 
  "stop-prompt", 
  "clear-ai-response", 
  "copy-ai-response"
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const mindmapStore = useMindmapStore();

// Props
const props = __props;

// Emits
const emit = __emit;

// State
const activeTab = ref<"prompts" | "properties" | "chat">("prompts");
const isEditingTitle = ref(false);
const editedTitle = ref("");
const isSavingTitle = ref(false);
const isEditingDescription = ref(false);
const editedDescription = ref("");
const isSaving = ref(false);
const chatContentRef = ref<HTMLDivElement | null>(null);

// Watch for node selection - auto switch to properties tab when node is selected
watch(
  () => props.selectedNode,
  (newNode) => {
    // Only auto-switch to properties when a node is selected
    // Don't auto-switch back to prompts when deselected (let user control tabs)
    if (newNode) {
      activeTab.value = "properties";
    }
  }
);

// Watch for AI response changes to scroll chat
watch(
  () => props.aiResponse,
  async () => {
    if (activeTab.value === 'chat' && chatContentRef.value) {
      await nextTick();
      chatContentRef.value.scrollTop = chatContentRef.value.scrollHeight;
    }
  }
);

// Expose method to set active tab
const setActiveTab = (tab: "prompts" | "properties" | "chat") => {
  activeTab.value = tab;
};

__expose({ setActiveTab });

// Helper to escape HTML for code blocks
const escapeHtml = (s: string) =>
  s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

// Format AI markdown-like response to HTML (copied from Mindmap.vue logic)
const formattedAiResponse = computed(() => {
  if (!props.aiResponse) return "";
  let text = props.aiResponse;

  // Code blocks (``` ... ```)
  text = text.replace(/```(\w*)\n?([\s\S]*?)```/g, (_, lang, code) => {
    return `<pre class="ai-code-block-small"><code class="lang-${lang || 'text'}">${escapeHtml(code.trim())}</code></pre>`;
  });

  // Inline code
  text = text.replace(/`([^`]+)`/g, '<code class="ai-inline-code-small">$1</code>');

  // Bold (**text**)
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Italic (*text*)
  text = text.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // Headers (### ## #)
  text = text.replace(/^### (.+)$/gm, '<h6 class="ai-h6">$1</h6>');
  text = text.replace(/^## (.+)$/gm, '<h5 class="ai-h5">$1</h5>');
  text = text.replace(/^# (.+)$/gm, '<h4 class="ai-h4">$1</h4>');

  // Unordered lists
  text = text.replace(/^[-*] (.+)$/gm, '<li>$1</li>');
  text = text.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

  // Numbered lists
  text = text.replace(/^\d+\. (.+)$/gm, '<li>$1</li>');

  // Line breaks
  text = text.replace(/\n\n/g, '</p><p>');
  text = text.replace(/\n/g, '<br/>');
  text = `<p>${text}</p>`;

  return text;
});

// Helper to check if node is a category (based on description pattern)
const isCategory = (node: any) => {
  return node.description && node.description.includes("Category with");
};

// Format date
const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString();
};

// Handle color change
const handleColorChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const newColor = target.value;
  if (props.selectedNode) {
    mindmapStore.updateNodeColor(props.selectedNode.id, newColor);
  }
};

// Handle forecolor change
const handleForecolorChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const newColor = target.value;
  if (props.selectedNode) {
    mindmapStore.updateNodeForecolor(props.selectedNode.id, newColor);
  }
};

// Start editing title
const startEditTitle = () => {
  if (props.selectedNode) {
    editedTitle.value = props.selectedNode.title || "";
    isEditingTitle.value = true;
  }
};

// Cancel title editing
const cancelEditTitle = () => {
  isEditingTitle.value = false;
  editedTitle.value = "";
};

// Save title
const saveTitle = async () => {
  if (!props.selectedNode || !editedTitle.value.trim()) return;

  isSavingTitle.value = true;
  try {
    // Check if it's the Start node (special UI-only node)
    const isStartNode =
      props.selectedNode.id === "start_node" ||
      props.selectedNode.variableId === "start";

    if (!isStartNode && props.selectedNode.variableId) {
      // Only save to database if it's not the Start node
      const endpoint = isCategory(props.selectedNode)
        ? "/common/prompt-categories"
        : "/common/prompt-variables";

      await apiService.put(endpoint, props.selectedNode.variableId, {
        title: editedTitle.value.trim(),
      });
    }

    // Update local node (works for both Start node and database nodes)
    mindmapStore.updateNodeTitle(
      props.selectedNode.id,
      editedTitle.value.trim()
    );
    isEditingTitle.value = false;
  } catch (error: any) {
    console.error("Error saving title:", error);
    alert(error?.response?.data?.message || "Failed to save title");
  } finally {
    isSavingTitle.value = false;
  }
};

// Start editing description
const startEditDescription = () => {
  if (props.selectedNode) {
    editedDescription.value = props.selectedNode.description || "";
    isEditingDescription.value = true;
  }
};

// Cancel editing
const cancelEditDescription = () => {
  isEditingDescription.value = false;
  editedDescription.value = "";
};

// Save description
const saveDescription = async () => {
  if (!props.selectedNode) return;

  isSaving.value = true;
  try {
    // Check if it's the Start node (special UI-only node)
    const isStartNode =
      props.selectedNode.id === "start_node" ||
      props.selectedNode.variableId === "start";

    if (!isStartNode && props.selectedNode.variableId) {
      // Only save to database if it's not the Start node
      const endpoint = isCategory(props.selectedNode)
        ? "/common/prompt-categories"
        : "/common/prompt-variables";

      await apiService.put(endpoint, props.selectedNode.variableId, {
        description: editedDescription.value,
      });
    }

    // Update local node (works for both Start node and database nodes)
    mindmapStore.updateNodeDescription(
      props.selectedNode.id,
      editedDescription.value
    );
    isEditingDescription.value = false;
  } catch (error: any) {
    console.error("Error saving description:", error);
    alert(error?.response?.data?.message || "Failed to save description");
  } finally {
    isSaving.value = false;
  }
};

// Add child node
const handleAddChildNode = () => {
  if (props.selectedNode) {
    emit("add-child-node", props.selectedNode.id);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["tab-button", { active: activeTab.value === 'prompts' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'prompts'))
      }, [...(_cache[13] || (_cache[13] = [
        _createElementVNode("i", { class: "fa fa-lightbulb me-1" }, null, -1),
        _createTextVNode(" Prompts ", -1)
      ]))], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["tab-button", { active: activeTab.value === 'properties' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'properties'))
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("i", { class: "fa fa-info-circle me-1" }, null, -1),
        _createTextVNode(" Properties ", -1)
      ]))], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["tab-button", { active: activeTab.value === 'chat' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'chat'))
      }, [...(_cache[15] || (_cache[15] = [
        _createElementVNode("i", { class: "fa fa-robot me-1" }, null, -1),
        _createTextVNode(" AI Chat ", -1)
      ]))], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["tab-pane", { 'active-pane': activeTab.value === 'prompts' }])
      }, [
        _createVNode(PromptPanel, {
          isActive: activeTab.value === 'prompts'
        }, null, 8, ["isActive"])
      ], 2), [
        [_vShow, activeTab.value === 'prompts']
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["tab-pane", { 'active-pane': activeTab.value === 'properties' }])
      }, [
        (!__props.selectedNode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("i", { class: "fa fa-hand-pointer fa-3x text-muted mb-3" }, null, -1),
              _createElementVNode("p", { class: "text-muted" }, "Select a node to view its properties", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "mb-0" }, "Node Properties", -1)),
                _createElementVNode("div", _hoisted_7, [
                  (isCategory(__props.selectedNode))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-success",
                        onClick: handleAddChildNode,
                        title: "Add child node"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                        _createTextVNode(" Add Child ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close-properties')))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                  ]))])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "property-label" }, "Title", -1)),
                  (!isEditingTitle.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(__props.selectedNode.title), 1),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-link text-primary ms-2",
                            onClick: startEditTitle,
                            title: "Edit title"
                          }, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                          ]))])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editedTitle).value = $event)),
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: "Enter title...",
                          onKeyup: [
                            _withKeys(saveTitle, ["enter"]),
                            _withKeys(cancelEditTitle, ["escape"])
                          ]
                        }, null, 544), [
                          [_vModelText, editedTitle.value]
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-success",
                            onClick: saveTitle,
                            disabled: isSavingTitle.value
                          }, [
                            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(isSavingTitle.value ? "Saving..." : "Save"), 1)
                          ], 8, _hoisted_14),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-secondary",
                            onClick: cancelEditTitle,
                            disabled: isSavingTitle.value
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                            _createTextVNode(" Cancel ", -1)
                          ]))], 8, _hoisted_15)
                        ])
                      ]))
                ]),
                (__props.selectedNode.slug)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "property-label" }, "Slug", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(__props.selectedNode.slug), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "property-label" }, "Description", -1)),
                  (!isEditingDescription.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (__props.selectedNode.description)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(__props.selectedNode.description), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, "No description")),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-link text-primary ms-2",
                            onClick: startEditDescription,
                            title: "Edit description"
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                          ]))])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editedDescription).value = $event)),
                          class: "form-control form-control-sm",
                          rows: "6",
                          placeholder: "Enter description...",
                          style: {"width":"100%","resize":"vertical"}
                        }, null, 512), [
                          [_vModelText, editedDescription.value]
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-success",
                            onClick: saveDescription,
                            disabled: isSaving.value
                          }, [
                            _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(isSaving.value ? "Saving..." : "Save"), 1)
                          ], 8, _hoisted_26),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-secondary",
                            onClick: cancelEditDescription,
                            disabled: isSaving.value
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                            _createTextVNode(" Cancel ", -1)
                          ]))], 8, _hoisted_27)
                        ])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "property-label" }, "Type", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", 
                    isCategory(__props.selectedNode)
                      ? 'bg-primary'
                      : __props.selectedNode.isRoot
                      ? 'bg-info'
                      : 'bg-success'
                  ])
                    }, _toDisplayString(isCategory(__props.selectedNode)
                      ? "Category Node"
                      : __props.selectedNode.isRoot
                      ? "Root Node"
                      : "Child Node"), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "property-label" }, "Background Color", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("input", {
                        type: "color",
                        value: __props.selectedNode.color,
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (handleColorChange($event))),
                        class: "color-input",
                        title: "Click to change background color"
                      }, null, 40, _hoisted_33),
                      _createElementVNode("div", {
                        class: "color-preview",
                        style: _normalizeStyle({ backgroundColor: __props.selectedNode.color })
                      }, null, 4),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(__props.selectedNode.color), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "property-label" }, "Text Color", -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("input", {
                        type: "color",
                        value: __props.selectedNode.forecolor || '#212529',
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (handleForecolorChange($event))),
                        class: "color-input",
                        title: "Click to change text color"
                      }, null, 40, _hoisted_38),
                      _createElementVNode("div", {
                        class: "color-preview",
                        style: _normalizeStyle({
                      backgroundColor: __props.selectedNode.forecolor || '#212529',
                    })
                      }, null, 4),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(__props.selectedNode.forecolor || "#212529"), 1)
                    ])
                  ])
                ])
              ])
            ]))
      ], 2), [
        [_vShow, activeTab.value === 'properties']
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["tab-pane chat-pane", { 'active-pane': activeTab.value === 'chat' }])
      }, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "ai-logo-small" }, [
                _createElementVNode("i", { class: "fa fa-robot" })
              ], -1)),
              _createElementVNode("div", _hoisted_43, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "fw-bold text-white small" }, "AI Assistant", -1)),
                _createElementVNode("div", _hoisted_44, _toDisplayString(__props.selectedModel), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              (__props.isRunningPrompt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("span", { class: "streaming-dot" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (__props.responseTokenCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(__props.responseTokenCount) + " tokens ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: "ai-chat-content",
            ref_key: "chatContentRef",
            ref: chatContentRef
          }, [
            (!__props.aiResponse && !__props.isRunningPrompt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "empty-icon" }, [
                    _createElementVNode("i", { class: "fa fa-comments" })
                  ], -1)),
                  _cache[37] || (_cache[37] = _createElementVNode("h6", null, "No conversation yet", -1)),
                  _cache[38] || (_cache[38] = _createElementVNode("p", null, "Generate a prompt and click \"Run Prompt\" to start a chat with AI.", -1)),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm mt-3",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('run-prompt')))
                  }, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "fa fa-play me-1" }, null, -1),
                    _createTextVNode(" Run Prompt ", -1)
                  ]))])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[40] || (_cache[40] = _createElementVNode("span", null, [
                        _createElementVNode("i", { class: "fa fa-robot me-1" }),
                        _createTextVNode(" AI Response")
                      ], -1)),
                      _createElementVNode("div", _hoisted_52, [
                        (__props.aiResponse)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "action-icon-btn",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('copy-ai-response'))),
                              title: "Copy response"
                            }, [...(_cache[39] || (_cache[39] = [
                              _createElementVNode("i", { class: "fa fa-copy" }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "ai-message-body",
                      innerHTML: formattedAiResponse.value
                    }, null, 8, _hoisted_53),
                    (__props.isRunningPrompt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, "▌"))
                      : _createCommentVNode("", true),
                    (!__props.aiResponse && __props.isRunningPrompt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [...(_cache[41] || (_cache[41] = [
                          _createElementVNode("div", { class: "thinking-dots" }, [
                            _createElementVNode("span"),
                            _createElementVNode("span"),
                            _createElementVNode("span")
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ], 512),
          _createElementVNode("div", _hoisted_56, [
            (__props.isRunningPrompt)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger btn-sm w-100",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('stop-prompt')))
                }, [...(_cache[42] || (_cache[42] = [
                  _createElementVNode("i", { class: "fa fa-stop me-1" }, null, -1),
                  _createTextVNode(" Stop Generating ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-sm flex-grow-1",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('clear-ai-response'))),
                    disabled: !__props.aiResponse
                  }, [...(_cache[43] || (_cache[43] = [
                    _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                    _createTextVNode(" Clear ", -1)
                  ]))], 8, _hoisted_58),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm flex-grow-1",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('run-prompt'))),
                    disabled: __props.isRunningPrompt
                  }, [...(_cache[44] || (_cache[44] = [
                    _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                    _createTextVNode(" Regenerate ", -1)
                  ]))], 8, _hoisted_59)
                ]))
          ])
        ])
      ], 2), [
        [_vShow, activeTab.value === 'chat']
      ])
    ])
  ]))
}
}

})